import { render } from "./HelpAndSupportPage.vue?vue&type=template&id=43fc2da7"
import script from "./HelpAndSupportPage.vue?vue&type=script&lang=js"
export * from "./HelpAndSupportPage.vue?vue&type=script&lang=js"

import "./HelpAndSupportPage.vue?vue&type=style&index=0&id=43fc2da7&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__